<template>
  <div class="view-order">
    <BottomBar />
    <keep-alive>
      <Modal
        v-if="components.customerService"
        @dismiss="components.customerService = false"
        :showComplete="false"
        :tapToDismiss="true"
      >
        <div class="customer-service">
          <Status v-if="isNewPayment && order.status === 1" :status="order.status" />
          <p>请添加小管家，以帮助您开始上课</p>
          <CustomerService :order_id="order_id" />
        </div>
      </Modal>
    </keep-alive>
    <Empty
      v-if="!order"
      :loading="order === undefined"
      :icon="true"
      title="查无订单"
      subtitle="找不到您要的订单，可能出现了错误"
      link="/contact"
      linkText="联系小管家"
    />
    <div v-else>
      <div class="top">
        <Price :price="order.order_price" />
        <Status :status="order.status" />
      </div>
      <div v-if="order.status === 0 || order.status === 2" class="info">
        <router-link tag="div" :to="payUrl" class="info-item info-button">
          <div class="right">重新支付</div>
          <i class="anyteachicon anyteach-next1" />
        </router-link>
      </div>
      <div class="info">
        <div class="info-item">
          <div class="left">购买课程</div>
          <div class="right">{{ order.title }}</div>
        </div>
        <div class="info-item">
          <div class="left">课程场次</div>
          <div class="right">{{ order.event_title }}</div>
        </div>
        <div class="info-item">
          <div class="left">课程原价</div>
          <div class="right">¥{{ order.price }}</div>
        </div>
        <div v-if="order.pay_time" class="info-item">
          <div class="left">支付时间</div>
          <div class="right">{{ $moment(order.pay_time).format("YYYY-MM-DD HH:mm") }}</div>
        </div>
        <div class="info-item">
          <div class="left">订单编号</div>
          <div class="right copy" :data-clipboard-text="order.order_id">
            <code>{{ order.order_id }}</code>
            <i class="anyteachicon anyteach-copy" />
          </div>
        </div>
        <div
          v-if="payMethod && (Number(order.order_price) || order.pay_method === 'store')"
          class="info-item"
        >
          <div class="left">支付方式</div>
          <div class="right">
            <i v-if="payMethod.icon" :class="payMethod.icon" />
            {{ payMethod.title }}
          </div>
        </div>
      </div>
      <div class="info">
        <div @click="components.customerService = true" class="info-item info-button">
          <div class="right">联系小管家</div>
          <i class="anyteachicon anyteach-next1" />
        </div>
        <router-link tag="div" :to="'/courses/' + order.c_id" class="info-item info-button">
          <div class="right">课程详情</div>
          <i class="anyteachicon anyteach-next1" />
        </router-link>
        <router-link tag="div" to="/payments" class="info-item info-button">
          <div class="right">查看更多订单</div>
          <i class="anyteachicon anyteach-next1" />
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Clipboard from "clipboard"
import Empty from "@/components/public/Empty"
import BottomBar from "@/components/public/footer"
import HeaderView from "@/components/v2/course/pay/Header"
import CustomerService from "@/components/public/CustomerService"
import Modal from "@/components/popup/Modal"
import Status from "./Status"
import Price from "./Price"

export default {
  name: "OrderView",
  data() {
    return {
      order_id: "",
      order: undefined,
      clipboard: null,
      components: {
        customerService: false,
        confirm: false
      }
    }
  },
  components: {
    Empty,
    Status,
    Price,
    HeaderView,
    BottomBar,
    CustomerService,
    Modal
  },
  computed: {
    payUrl() {
      if (!this.order) return null
      return `/courses/${this.order.c_id}?pay=1&cd_id=${this.order.cd_id}&method=${this.order.pay_method}`
    },
    query() {
      return this.$route.query
    },
    isNewPayment() {
      return Boolean(this.query.out_trade_no)
    },
    payMethod() {
      if (!this.order.pay_method) return null
      const methods = {
        alipay: {
          icon: "anyteachicon anyteach-alipay",
          title: "支付宝",
        },
        wechat: {
          icon: "anyteachicon anyteach-wechat-pay",
          title: "微信支付"
        },
        wechat_h5: {
          icon: "anyteachicon anyteach-wechat-pay",
          title: "微信支付"
        },
        store: {
          title: "优学卡"
        }
      }
      return methods[this.order.pay_method]
    }
  },
  methods: {
    setClipboard() {
      this.clipboard = new Clipboard(".copy")
      this.clipboard.on("success", e => {
        this.$toastSuccess("已复制订单号")
      })
      this.clipboard.on("error", e => {
        this.$toastError("复制失败")
      })
    },
    async getOrder() {
      const { code, msg } = await this.$api.order.GET_ORDER(this.order_id)
      if (code !== "1000") {
        this.order = null
        return this.$toastError(msg)
      }
      this.order = msg
      this.$nextTick(() => this.setClipboard())
      if (this.order && this.order.status === 1 && this.isNewPayment) {
        this.components.customerService = true
      }
      const isRecent = this.$moment().isBefore(this.$moment(this.order.create_time).add(5, "minutes"))
      if (this.order.status === 0 && this.order.pay_method === "wechat_h5" && isRecent) {
        const timeout = setTimeout(() => this.getOrder(), 1500)
        this.$on("hook:beforeDestroy", () => window.clearTimeout(timeout))
      }
    }
  },
  mounted() {
    this.order_id = this.query.out_trade_no || this.query.order_id || null
    if (!this.order_id) {
      this.order = null
    } else {
      this.getOrder()
    }
  }
}
</script>

<style lang="scss" scoped>
.customer-service {
  text-align: center;
  p {
    opacity: 0.6;
  }
}

.info {
  border: $border;
  border-radius: 4px;
  width: 80%;
  margin: 15px auto;
  padding: 10px;
  background: white;
  box-shadow: $deep-shadow;

  .info-item {
    display: flex;
    justify-content: space-between;
    padding: 0 0 5px 0;
    font-size: 0.9rem;
    &:last-of-type {
      padding: 0;
    }
    .left {
      opacity: 0.6;
      min-width: 60px;
    }
    .right {
      text-align: right;
      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .right,
    code {
      -o-user-select: text;
      -moz-user-select: text;
      -webkit-user-select: text;
      user-select: text;
    }
    .copy {
      &:active {
        i {
          opacity: 0.6;
        }
      }
      i {
        margin-left: 5px;
        transition: all 0.1s;
        &:active {
          opacity: 0.6;
        }
      }
    }
  }
  .info-button {
    margin: 0 0 8px 0;
    padding: 0 0 8px 0;
    border-bottom: $border;
    transition: all 0.1s;
    .right {
      // color: $blue;
    }
    &:active {
      opacity: 0.6;
    }
    &:last-of-type {
      margin: 0;
      border: none;
    }
  }
}

@media only screen and (max-width: 320px) {
  .info {
    width: 90%;
  }
}
</style>